<template>
  <keep-alive>
    <component v-bind:is="currentGridComponent"></component>
  </keep-alive>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { openApp } from '../shared/helpers'
import AccountMain from '../components/AccountMain.vue'
import ChangePassword from '../components/ChangePassword.vue'

export default {
  name: 'appSelection',
  components: {
    AccountMain,
    ChangePassword,
  },
  data() {
    return {
      currentGridComponent: null,
    }
  },
  async mounted() {
    if (this.currentAccountComponent === 'AccountMain') {
      this.currentGridComponent = AccountMain
    } else {
      this.setAccountComponent('AccountMain')
    }
  },
  methods: {
    ...mapActions(['getApps', 'getUser', 'logoffUser']),
    ...mapMutations(['setAccountComponent']),
  },
  computed: {
    ...mapState([
      'applications',
      'user',
      'userToAppMappings',
      'currentAccountComponent',
    ]),
  },
  watch: {
    currentAccountComponent(newVal) {
      if (newVal === 'AccountMain') {
        this.currentGridComponent = AccountMain
      } else if (newVal === 'ChangePassword') {
        this.currentGridComponent = ChangePassword
      }
    },
  },
}
</script>

<style>
.sornBG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.center {
  align-items: center;
}
</style>
